import React, { Component } from 'react'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'


let select = (state) => state


export class InputWeb extends Component {
	constructor(props) {
		super(props);
			this.state = {
				value: (this.props.value)?this.props.value:'',

			}
		}
		componentDidMount(){
			if (this.props.value){

				this.setState({value: this.props.value.toString()})

			}
		}
		render() {
			return (
				<div style={{...this.props.style}}>
					<TextField
						disabled={(this.props.disabled)?this.props.disabled:false}
						inputStyle={(this.props.inputStyle)?this.props.inputStyle:{fontSize: "14", color:"#000000"}}
						underlineStyle={(this.props.underlineStyle)?this.props.underlineStyle:{borderBottom: "0px solid"}}
						defaultValue={this.state.value}
						hintText={(this.props.hintText)?this.props.hintText:"Enter here"}
						hintStyle={(this.props.hintStyle)?this.props.hintStyle:{fontStyle: "italic", fontSize: "14px"}}
						key={(this.props.key)?this.props.key:''}
						ref={(this.props.ref)?this.props.ref:''}
						floatingLabelText={(this.props.floatingLabelText)?this.props.floatingLabelText:''}
						style={{width: "calc(100% - 24px)"}}
						onBlur={(evt) => {
							this.setState({value: evt.target.value})
							this.props.onBlur(evt.target.value)}}
					/>
						<a
							href={
								(this.state.value.substring(0, 4)!="http")?
								`http://${this.state.value}`:
								this.state.value
							}
							target="_blank"
						>
							<i className="material-icons"
							style = {{color: (this.props.color)?this.props.color:"#3cd2ae", cursor: "pointer", position: "relative", top: "8px"}}
							>
							forward
							</i>
						</a>
				</div>
			)
		}
}

export default connect(select)(InputWeb)



// WEBPACK FOOTER //
// ./src/components/InputWeb.js